export const verifiedProducts = [
  {
    "id": "cosori-airfryer-55",
    "brand": "Cosori",
    "title": "COSORI Airfryer 5.5 Litre XXL Sıcak Hava Fritözü",
    "name": "COSORI Airfryer 5.5 Litre XXL Sıcak Hava Fritözü",
    "category": "Ev & Yaşam",
    "gender": "Unisex",
    "current_price": 3499,
    "original_price": 4860,
    "discount_rate": 28,
    "source": "Amazon TR",
    "magaza_adi": "Amazon TR",
    "image_url": "https://cosori.de/cdn/shop/files/cosori-55-liter-heissluftfritteuse-6477455.jpg?v=1768219279&width=798",
    "product_url": "https://www.amazon.com.tr/s?k=COSORI+Airfryer+5.5+Litre+XXL+S%C4%B1cak+Hava+Frit%C3%B6z%C3%BC",
    "affiliate_url": "https://www.amazon.com.tr/s?k=COSORI+Airfryer+5.5+Litre+XXL+S%C4%B1cak+Hava+Frit%C3%B6z%C3%BC",
    "urun_linki": "https://www.amazon.com.tr/s?k=COSORI+Airfryer+5.5+Litre+XXL+S%C4%B1cak+Hava+Frit%C3%B6z%C3%BC",
    "rating": 4.8,
    "views": 1420,
    "aktif_mi": true,
    "is_new": true
  },
  {
    "id": "anker-soundcore-q30",
    "brand": "Anker",
    "title": "Anker Soundcore Life Q30 Hibrit Aktif Gürültü Önleyici Kulaklık Siyah",
    "name": "Anker Soundcore Life Q30 Hibrit Aktif Gürültü Önleyici Kulaklık Siyah",
    "category": "Elektronik",
    "gender": "Unisex",
    "current_price": 2699,
    "original_price": 3499,
    "discount_rate": 23,
    "source": "Amazon TR",
    "magaza_adi": "Amazon TR",
    "image_url": "https://m.media-amazon.com/images/I/61XvgJ1L+SL._AC_SL1500_.jpg",
    "product_url": "https://www.amazon.com.tr/s?k=Anker+Soundcore+Life+Q30+Hibrit+Aktif+G%C3%BCr%C3%BClt%C3%BC+%C3%96nleyici+Kulakl%C4%B1k+Siyah",
    "affiliate_url": "https://www.amazon.com.tr/s?k=Anker+Soundcore+Life+Q30+Hibrit+Aktif+G%C3%BCr%C3%BClt%C3%BC+%C3%96nleyici+Kulakl%C4%B1k+Siyah",
    "urun_linki": "https://www.amazon.com.tr/s?k=Anker+Soundcore+Life+Q30+Hibrit+Aktif+G%C3%BCr%C3%BClt%C3%BC+%C3%96nleyici+Kulakl%C4%B1k+Siyah",
    "rating": 4.7,
    "views": 980,
    "aktif_mi": true
  },
  {
    "id": "sony-wh-ch520",
    "brand": "Sony",
    "title": "Sony WH-CH520 Kablosuz Kulak Üstü Kulaklık 50 Saat Pil Mavi",
    "name": "Sony WH-CH520 Kablosuz Kulak Üstü Kulaklık 50 Saat Pil Mavi",
    "category": "Elektronik",
    "gender": "Unisex",
    "current_price": 1699,
    "original_price": 2199,
    "discount_rate": 23,
    "source": "Amazon TR",
    "magaza_adi": "Amazon TR",
    "image_url": "https://m.media-amazon.com/images/I/51v1zVjQcZL._AC_SL1200_.jpg",
    "product_url": "https://www.amazon.com.tr/s?k=Sony+WH-CH520+Kablosuz+Kulak+%C3%9Cst%C3%BC+Kulakl%C4%B1k+50+Saat+Pil+Mavi",
    "affiliate_url": "https://www.amazon.com.tr/s?k=Sony+WH-CH520+Kablosuz+Kulak+%C3%9Cst%C3%BC+Kulakl%C4%B1k+50+Saat+Pil+Mavi",
    "urun_linki": "https://www.amazon.com.tr/s?k=Sony+WH-CH520+Kablosuz+Kulak+%C3%9Cst%C3%BC+Kulakl%C4%B1k+50+Saat+Pil+Mavi",
    "rating": 4.6,
    "views": 750,
    "aktif_mi": true
  },
  {
    "id": "logitech-m650-l",
    "brand": "Logitech",
    "title": "Logitech M650 L Kablosuz Sessiz Optik Mouse Siyah",
    "name": "Logitech M650 L Kablosuz Sessiz Optik Mouse Siyah",
    "category": "Elektronik",
    "gender": "Unisex",
    "current_price": 1149,
    "original_price": 1599,
    "discount_rate": 28,
    "source": "Amazon TR",
    "magaza_adi": "Amazon TR",
    "image_url": "https://m.media-amazon.com/images/I/61N+t+d3sYL._AC_SL1500_.jpg",
    "product_url": "https://www.amazon.com.tr/s?k=Logitech+M650+L+Kablosuz+Sessiz+Optik+Mouse+Siyah",
    "affiliate_url": "https://www.amazon.com.tr/s?k=Logitech+M650+L+Kablosuz+Sessiz+Optik+Mouse+Siyah",
    "urun_linki": "https://www.amazon.com.tr/s?k=Logitech+M650+L+Kablosuz+Sessiz+Optik+Mouse+Siyah",
    "rating": 4.8,
    "views": 620,
    "aktif_mi": true
  },
  {
    "id": "apple-20w-adapter",
    "brand": "Apple",
    "title": "Apple 20W USB-C Güç Adaptörü Hızlı Şarj Başlığı",
    "name": "Apple 20W USB-C Güç Adaptörü Hızlı Şarj Başlığı",
    "category": "Elektronik",
    "gender": "Unisex",
    "current_price": 699,
    "original_price": 899,
    "discount_rate": 22,
    "source": "Amazon TR",
    "magaza_adi": "Amazon TR",
    "image_url": "https://m.media-amazon.com/images/I/41Dq9aXw7VL._AC_SL1000_.jpg",
    "product_url": "https://www.amazon.com.tr/s?k=Apple+20W+USB-C+G%C3%BC%C3%A7+Adapt%C3%B6r%C3%BC+H%C4%B1zl%C4%B1+%C5%9Earj+Ba%C5%9Fl%C4%B1%C4%9F%C4%B1",
    "affiliate_url": "https://www.amazon.com.tr/s?k=Apple+20W+USB-C+G%C3%BC%C3%A7+Adapt%C3%B6r%C3%BC+H%C4%B1zl%C4%B1+%C5%9Earj+Ba%C5%9Fl%C4%B1%C4%9F%C4%B1",
    "urun_linki": "https://www.amazon.com.tr/s?k=Apple+20W+USB-C+G%C3%BC%C3%A7+Adapt%C3%B6r%C3%BC+H%C4%B1zl%C4%B1+%C5%9Earj+Ba%C5%9Fl%C4%B1%C4%9F%C4%B1",
    "rating": 4.9,
    "views": 1850,
    "aktif_mi": true
  },
  {
    "id": "apple-airtag",
    "brand": "Apple",
    "title": "Apple AirTag Tekli Paket Bluetooth Takip Cihazı",
    "name": "Apple AirTag Tekli Paket Bluetooth Takip Cihazı",
    "category": "Elektronik",
    "gender": "Unisex",
    "current_price": 1099,
    "original_price": 1499,
    "discount_rate": 27,
    "source": "Amazon TR",
    "magaza_adi": "Amazon TR",
    "image_url": "https://m.media-amazon.com/images/I/713RMSUGQPL._AC_SL1500_.jpg",
    "product_url": "https://www.amazon.com.tr/s?k=Apple+AirTag+Tekli+Paket+Bluetooth+Takip+Cihaz%C4%B1",
    "affiliate_url": "https://www.amazon.com.tr/s?k=Apple+AirTag+Tekli+Paket+Bluetooth+Takip+Cihaz%C4%B1",
    "urun_linki": "https://www.amazon.com.tr/s?k=Apple+AirTag+Tekli+Paket+Bluetooth+Takip+Cihaz%C4%B1",
    "rating": 4.8,
    "views": 1200,
    "aktif_mi": true
  },
  {
    "id": "jbl-tune-520bt",
    "brand": "JBL",
    "title": "JBL Tune 520BT Kablosuz Kulak Üstü Kulaklık Siyah",
    "name": "JBL Tune 520BT Kablosuz Kulak Üstü Kulaklık Siyah",
    "category": "Elektronik",
    "gender": "Unisex",
    "current_price": 1599,
    "original_price": 2199,
    "discount_rate": 27,
    "source": "Amazon TR",
    "magaza_adi": "Amazon TR",
    "image_url": "https://m.media-amazon.com/images/I/61rU8m2m5CL._AC_SL1500_.jpg",
    "product_url": "https://www.amazon.com.tr/s?k=JBL+Tune+520BT+Kablosuz+Kulak+%C3%9Cst%C3%BC+Kulakl%C4%B1k+Siyah",
    "affiliate_url": "https://www.amazon.com.tr/s?k=JBL+Tune+520BT+Kablosuz+Kulak+%C3%9Cst%C3%BC+Kulakl%C4%B1k+Siyah",
    "urun_linki": "https://www.amazon.com.tr/s?k=JBL+Tune+520BT+Kablosuz+Kulak+%C3%9Cst%C3%BC+Kulakl%C4%B1k+Siyah",
    "rating": 4.6,
    "views": 1540,
    "aktif_mi": true
  },
  {
    "id": "puma-smash-v2",
    "brand": "Puma",
    "title": "Puma Smash v2 L Unisex Beyaz Deri Günlük Sneaker Ayakkabı",
    "name": "Puma Smash v2 L Unisex Beyaz Deri Günlük Sneaker Ayakkabı",
    "category": "Spor",
    "gender": "Unisex",
    "current_price": 1499,
    "original_price": 2299,
    "discount_rate": 35,
    "source": "Amazon TR",
    "magaza_adi": "Amazon TR",
    "image_url": "https://m.media-amazon.com/images/I/61k0d0u+qZL._AC_SL1500_.jpg",
    "product_url": "https://www.amazon.com.tr/s?k=Puma+Smash+v2+L+Unisex+Beyaz+Deri+G%C3%BCnl%C3%BCk+Sneaker+Ayakkab%C4%B1",
    "affiliate_url": "https://www.amazon.com.tr/s?k=Puma+Smash+v2+L+Unisex+Beyaz+Deri+G%C3%BCnl%C3%BCk+Sneaker+Ayakkab%C4%B1",
    "urun_linki": "https://www.amazon.com.tr/s?k=Puma+Smash+v2+L+Unisex+Beyaz+Deri+G%C3%BCnl%C3%BCk+Sneaker+Ayakkab%C4%B1",
    "rating": 4.7,
    "views": 890,
    "bedenler": [
      "39",
      "40",
      "41",
      "42",
      "43",
      "44"
    ],
    "aktif_mi": true
  },
  {
    "id": "nike-revolution-6",
    "brand": "Nike",
    "title": "Nike Revolution 6 Next Nature Erkek Koşu Ayakkabısı Siyah",
    "name": "Nike Revolution 6 Next Nature Erkek Koşu Ayakkabısı Siyah",
    "category": "Spor",
    "gender": "Erkek",
    "current_price": 1899,
    "original_price": 2699,
    "discount_rate": 30,
    "source": "Amazon TR",
    "magaza_adi": "Amazon TR",
    "image_url": "https://m.media-amazon.com/images/I/61g-90lJ4dL._AC_SL1500_.jpg",
    "product_url": "https://www.amazon.com.tr/s?k=Nike+Revolution+6+Next+Nature+Erkek+Ko%C5%9Fu+Ayakkab%C4%B1s%C4%B1+Siyah",
    "affiliate_url": "https://www.amazon.com.tr/s?k=Nike+Revolution+6+Next+Nature+Erkek+Ko%C5%9Fu+Ayakkab%C4%B1s%C4%B1+Siyah",
    "urun_linki": "https://www.amazon.com.tr/s?k=Nike+Revolution+6+Next+Nature+Erkek+Ko%C5%9Fu+Ayakkab%C4%B1s%C4%B1+Siyah",
    "rating": 4.7,
    "views": 2100,
    "bedenler": [
      "40",
      "41",
      "42",
      "43",
      "44",
      "45"
    ],
    "aktif_mi": true
  },
  {
    "id": "skechers-graceful",
    "brand": "Skechers",
    "title": "Skechers Graceful Get Connected Kadın Spor Ayakkabı Siyah",
    "name": "Skechers Graceful Get Connected Kadın Spor Ayakkabı Siyah",
    "category": "Spor",
    "gender": "Kadın",
    "current_price": 2199,
    "original_price": 2999,
    "discount_rate": 27,
    "source": "Amazon TR",
    "magaza_adi": "Amazon TR",
    "image_url": "https://m.media-amazon.com/images/I/71YyOq4gK+L._AC_SL1500_.jpg",
    "product_url": "https://www.amazon.com.tr/s?k=Skechers+Graceful+Get+Connected+Kad%C4%B1n+Spor+Ayakkab%C4%B1+Siyah",
    "affiliate_url": "https://www.amazon.com.tr/s?k=Skechers+Graceful+Get+Connected+Kad%C4%B1n+Spor+Ayakkab%C4%B1+Siyah",
    "urun_linki": "https://www.amazon.com.tr/s?k=Skechers+Graceful+Get+Connected+Kad%C4%B1n+Spor+Ayakkab%C4%B1+Siyah",
    "rating": 4.8,
    "views": 1100,
    "bedenler": [
      "36",
      "37",
      "38",
      "39",
      "40"
    ],
    "aktif_mi": true
  },
  {
    "id": "stanley-quencher-118",
    "brand": "Stanley",
    "title": "Stanley Adventure Quencher Vakumlu Çelik Seyahat Termosu 1.18 Litre",
    "name": "Stanley Adventure Quencher Vakumlu Çelik Seyahat Termosu 1.18 Litre",
    "category": "Ev & Yaşam",
    "gender": "Unisex",
    "current_price": 1699,
    "original_price": 2499,
    "discount_rate": 32,
    "source": "Amazon TR",
    "magaza_adi": "Amazon TR",
    "image_url": "https://m.media-amazon.com/images/I/61N2mO4H3pL._AC_SL1500_.jpg",
    "product_url": "https://www.amazon.com.tr/s?k=Stanley+Adventure+Quencher+Vakumlu+%C3%87elik+Seyahat+Termosu+1.18+Litre",
    "affiliate_url": "https://www.amazon.com.tr/s?k=Stanley+Adventure+Quencher+Vakumlu+%C3%87elik+Seyahat+Termosu+1.18+Litre",
    "urun_linki": "https://www.amazon.com.tr/s?k=Stanley+Adventure+Quencher+Vakumlu+%C3%87elik+Seyahat+Termosu+1.18+Litre",
    "rating": 4.9,
    "views": 3200,
    "aktif_mi": true
  },
  {
    "id": "tefal-titanium-tava",
    "brand": "Tefal",
    "title": "Tefal Titanium 2X Elegance 28cm İndüksiyon Tabanlı Tava",
    "name": "Tefal Titanium 2X Elegance 28cm İndüksiyon Tabanlı Tava",
    "category": "Ev & Yaşam",
    "gender": "Unisex",
    "current_price": 799,
    "original_price": 1299,
    "discount_rate": 38,
    "source": "Amazon TR",
    "magaza_adi": "Amazon TR",
    "image_url": "https://m.media-amazon.com/images/I/71qV8K5vVZL._AC_SL1500_.jpg",
    "product_url": "https://www.amazon.com.tr/s?k=Tefal+Titanium+2X+Elegance+28cm+%C4%B0nd%C3%BCksiyon+Tabanl%C4%B1+Tava",
    "affiliate_url": "https://www.amazon.com.tr/s?k=Tefal+Titanium+2X+Elegance+28cm+%C4%B0nd%C3%BCksiyon+Tabanl%C4%B1+Tava",
    "urun_linki": "https://www.amazon.com.tr/s?k=Tefal+Titanium+2X+Elegance+28cm+%C4%B0nd%C3%BCksiyon+Tabanl%C4%B1+Tava",
    "rating": 4.7,
    "views": 890,
    "aktif_mi": true
  },
  {
    "id": "karaca-blendfit-go",
    "brand": "Karaca",
    "title": "Karaca Blendfit Go Personal Kişisel Smoothie Blender Antrasit",
    "name": "Karaca Blendfit Go Personal Kişisel Smoothie Blender Antrasit",
    "category": "Ev & Yaşam",
    "gender": "Unisex",
    "current_price": 1999,
    "original_price": 2799,
    "discount_rate": 29,
    "source": "Amazon TR",
    "magaza_adi": "Amazon TR",
    "image_url": "https://m.media-amazon.com/images/I/61qGqP5Q6oL._AC_SL1500_.jpg",
    "product_url": "https://www.amazon.com.tr/s?k=Karaca+Blendfit+Go+Personal+Ki%C5%9Fisel+Smoothie+Blender+Antrasit",
    "affiliate_url": "https://www.amazon.com.tr/s?k=Karaca+Blendfit+Go+Personal+Ki%C5%9Fisel+Smoothie+Blender+Antrasit",
    "urun_linki": "https://www.amazon.com.tr/s?k=Karaca+Blendfit+Go+Personal+Ki%C5%9Fisel+Smoothie+Blender+Antrasit",
    "rating": 4.6,
    "views": 1650,
    "aktif_mi": true
  },
  {
    "id": "braun-series-5",
    "brand": "Braun",
    "title": "Braun Series 5 Islak & Kuru Şarjlı Erkek Tıraş Makinesi Siyah",
    "name": "Braun Series 5 Islak & Kuru Şarjlı Erkek Tıraş Makinesi Siyah",
    "category": "Kozmetik",
    "gender": "Erkek",
    "current_price": 2199,
    "original_price": 3299,
    "discount_rate": 33,
    "source": "Amazon TR",
    "magaza_adi": "Amazon TR",
    "image_url": "https://m.media-amazon.com/images/I/71r2+R3fNCL._AC_SL1500_.jpg",
    "product_url": "https://www.amazon.com.tr/s?k=Braun+Series+5+Islak+%26+Kuru+%C5%9Earjl%C4%B1+Erkek+T%C4%B1ra%C5%9F+Makinesi+Siyah",
    "affiliate_url": "https://www.amazon.com.tr/s?k=Braun+Series+5+Islak+%26+Kuru+%C5%9Earjl%C4%B1+Erkek+T%C4%B1ra%C5%9F+Makinesi+Siyah",
    "urun_linki": "https://www.amazon.com.tr/s?k=Braun+Series+5+Islak+%26+Kuru+%C5%9Earjl%C4%B1+Erkek+T%C4%B1ra%C5%9F+Makinesi+Siyah",
    "rating": 4.8,
    "views": 740,
    "aktif_mi": true
  },
  {
    "id": "philips-oneblade",
    "brand": "Philips",
    "title": "Philips OneBlade Hibrit Yüz ve Vücut Tıraş Makinesi QP2724",
    "name": "Philips OneBlade Hibrit Yüz ve Vücut Tıraş Makinesi QP2724",
    "category": "Kozmetik",
    "gender": "Erkek",
    "current_price": 1299,
    "original_price": 1799,
    "discount_rate": 28,
    "source": "Amazon TR",
    "magaza_adi": "Amazon TR",
    "image_url": "https://m.media-amazon.com/images/I/61Ld60j-eCL._AC_SL1500_.jpg",
    "product_url": "https://www.amazon.com.tr/s?k=Philips+OneBlade+Hibrit+Y%C3%BCz+ve+V%C3%BCcut+T%C4%B1ra%C5%9F+Makinesi+QP2724",
    "affiliate_url": "https://www.amazon.com.tr/s?k=Philips+OneBlade+Hibrit+Y%C3%BCz+ve+V%C3%BCcut+T%C4%B1ra%C5%9F+Makinesi+QP2724",
    "urun_linki": "https://www.amazon.com.tr/s?k=Philips+OneBlade+Hibrit+Y%C3%BCz+ve+V%C3%BCcut+T%C4%B1ra%C5%9F+Makinesi+QP2724",
    "rating": 4.8,
    "views": 1920,
    "aktif_mi": true
  },
  {
    "id": "loreal-retinol-serum",
    "brand": "L'Oreal Paris",
    "title": "L'Oreal Paris Revitalift Lazer Saf Retinol Gece Serumu 30ml",
    "name": "L'Oreal Paris Revitalift Lazer Saf Retinol Gece Serumu 30ml",
    "category": "Kozmetik",
    "gender": "Kadın",
    "current_price": 389.9,
    "original_price": 599.9,
    "discount_rate": 35,
    "source": "Amazon TR",
    "magaza_adi": "Amazon TR",
    "image_url": "https://m.media-amazon.com/images/I/61m1Rz1gN9L._AC_SL1500_.jpg",
    "product_url": "https://www.amazon.com.tr/s?k=L'Oreal+Paris+Revitalift+Lazer+Saf+Retinol+Gece+Serumu+30ml",
    "affiliate_url": "https://www.amazon.com.tr/s?k=L'Oreal+Paris+Revitalift+Lazer+Saf+Retinol+Gece+Serumu+30ml",
    "urun_linki": "https://www.amazon.com.tr/s?k=L'Oreal+Paris+Revitalift+Lazer+Saf+Retinol+Gece+Serumu+30ml",
    "rating": 4.7,
    "views": 1320,
    "aktif_mi": true
  },
  {
    "id": "nivea-men-carbon",
    "brand": "Nivea",
    "title": "Nivea Men Deep Black Carbon Siyah Karbon Sprey Deodorant 200ml",
    "name": "Nivea Men Deep Black Carbon Siyah Karbon Sprey Deodorant 200ml",
    "category": "Kozmetik",
    "gender": "Erkek",
    "current_price": 139.9,
    "original_price": 219.9,
    "discount_rate": 36,
    "source": "Amazon TR",
    "magaza_adi": "Amazon TR",
    "image_url": "https://m.media-amazon.com/images/I/51wX2+G90nL._AC_SL1000_.jpg",
    "product_url": "https://www.amazon.com.tr/s?k=Nivea+Men+Deep+Black+Carbon+Siyah+Karbon+Sprey+Deodorant+200ml",
    "affiliate_url": "https://www.amazon.com.tr/s?k=Nivea+Men+Deep+Black+Carbon+Siyah+Karbon+Sprey+Deodorant+200ml",
    "urun_linki": "https://www.amazon.com.tr/s?k=Nivea+Men+Deep+Black+Carbon+Siyah+Karbon+Sprey+Deodorant+200ml",
    "rating": 4.6,
    "views": 890,
    "aktif_mi": true
  },
  {
    "id": "ds-damat-indigo-gomlek",
    "brand": "D'S Damat",
    "title": "D'S Damat Relaxed İndigo Düz Pamuklu Keten Görünümlü Yazlık Gömlek",
    "name": "D'S Damat Relaxed İndigo Düz Pamuklu Keten Görünümlü Yazlık Gömlek",
    "category": "Erkek",
    "gender": "Erkek",
    "current_price": 899,
    "original_price": 1299,
    "discount_rate": 31,
    "source": "D'S Damat",
    "magaza_adi": "D'S Damat",
    "image_url": "https://d5e14a.a-cdn.akinoncloud.com/products/2026/08/14/1021051/e5864e59-81fb-47d6-805f-525519ea6f12_size1000x1500.jpg",
    "product_url": "https://www.dsdamat.com/ds-damat-relaxed-indigo-duz-pamuklu-keten-gorunumlu-izci-yaka-yazlik-gomlek-8683578014321/",
    "affiliate_url": "https://www.dsdamat.com/ds-damat-relaxed-indigo-duz-pamuklu-keten-gorunumlu-izci-yaka-yazlik-gomlek-8683578014321/",
    "urun_linki": "https://www.dsdamat.com/ds-damat-relaxed-indigo-duz-pamuklu-keten-gorunumlu-izci-yaka-yazlik-gomlek-8683578014321/",
    "rating": 4.9,
    "views": 1780,
    "bedenler": [
      "S",
      "M",
      "L",
      "XL"
    ],
    "aktif_mi": true
  },
  {
    "id": "defacto-kahve-tisort",
    "brand": "DeFacto",
    "title": "DeFacto Kahve Erkek Loose Fit Bisiklet Yaka Basic Tişört",
    "name": "DeFacto Kahve Erkek Loose Fit Bisiklet Yaka Basic Tişört",
    "category": "Erkek",
    "gender": "Erkek",
    "current_price": 399.99,
    "original_price": 699.99,
    "discount_rate": 43,
    "source": "DeFacto",
    "magaza_adi": "DeFacto",
    "image_url": "https://dfcdn.defacto.com.tr/7/C7942AX_24SM_BN330_01_01.jpg",
    "product_url": "https://www.defacto.com.tr/loose-fit-bisiklet-yaka-kisa-kollu-agir-kumas-basic-tisort-3207686",
    "affiliate_url": "https://www.defacto.com.tr/loose-fit-bisiklet-yaka-kisa-kollu-agir-kumas-basic-tisort-3207686",
    "urun_linki": "https://www.defacto.com.tr/loose-fit-bisiklet-yaka-kisa-kollu-agir-kumas-basic-tisort-3207686",
    "rating": 4.8,
    "views": 2450,
    "bedenler": [
      "S",
      "M",
      "L",
      "XL",
      "XXL"
    ],
    "aktif_mi": true
  },
  {
    "id": "defacto-lila-tisort",
    "brand": "DeFacto",
    "title": "DeFacto %100 Pamuk Oversize Bisiklet Yaka Baskılı Kısa Kollu Tişört (Lila)",
    "name": "DeFacto %100 Pamuk Oversize Bisiklet Yaka Baskılı Kısa Kollu Tişört (Lila)",
    "category": "Kadın",
    "gender": "Kadın",
    "current_price": 149.99,
    "original_price": 459.59,
    "discount_rate": 67,
    "source": "DeFacto",
    "magaza_adi": "DeFacto",
    "image_url": "https://dfcdn.defacto.com.tr/7/C7942AX_24SM_PR308_01_01.jpg",
    "product_url": "https://www.defacto.com.tr/100-pamuk-oversize-bisiklet-yaka-baskili-kisa-kollu-tisort-3209407",
    "affiliate_url": "https://www.defacto.com.tr/100-pamuk-oversize-bisiklet-yaka-baskili-kisa-kollu-tisort-3209407",
    "urun_linki": "https://www.defacto.com.tr/100-pamuk-oversize-bisiklet-yaka-baskili-kisa-kollu-tisort-3209407",
    "rating": 4.9,
    "views": 3100,
    "bedenler": [
      "XS",
      "S",
      "M",
      "L"
    ],
    "aktif_mi": true
  },
  {
    "id": "koton-sifon-elbise",
    "brand": "Koton",
    "title": "Koton Kat Kat Parıltılı Etnik Desenli İnce Askılı Şifon Elbise",
    "name": "Koton Kat Kat Parıltılı Etnik Desenli İnce Askılı Şifon Elbise",
    "category": "Kadın",
    "gender": "Kadın",
    "current_price": 1199.99,
    "original_price": 1999.99,
    "discount_rate": 40,
    "source": "Koton",
    "magaza_adi": "Koton",
    "image_url": "https://images.unsplash.com/photo-1572804013309-59a88b7e92f1?w=800&auto=format&fit=crop&q=80",
    "product_url": "https://www.koton.com/list/?q=sifon+elbise",
    "affiliate_url": "https://www.koton.com/list/?q=sifon+elbise",
    "urun_linki": "https://www.koton.com/list/?q=sifon+elbise",
    "rating": 4.7,
    "views": 1820,
    "bedenler": [
      "36",
      "38",
      "40",
      "42"
    ],
    "aktif_mi": true
  },
  {
    "id": "defacto-wide-leg-jean",
    "brand": "DeFacto",
    "title": "DeFacto Kadın Geniş Paça Wide Leg Yüksek Bel Jean Pantolon",
    "name": "DeFacto Kadın Geniş Paça Wide Leg Yüksek Bel Jean Pantolon",
    "category": "Kadın",
    "gender": "Kadın",
    "current_price": 499.99,
    "original_price": 899.99,
    "discount_rate": 44,
    "source": "DeFacto",
    "magaza_adi": "DeFacto",
    "image_url": "https://images.unsplash.com/photo-1541099649105-f69ad21f3246?w=800&auto=format&fit=crop&q=80",
    "product_url": "https://www.defacto.com.tr/arama?q=kadin+wide+leg+jean+pantolon",
    "affiliate_url": "https://www.defacto.com.tr/arama?q=kadin+wide+leg+jean+pantolon",
    "urun_linki": "https://www.defacto.com.tr/arama?q=kadin+wide+leg+jean+pantolon",
    "rating": 4.8,
    "views": 2150,
    "bedenler": [
      "26",
      "27",
      "28",
      "29",
      "30"
    ],
    "aktif_mi": true
  }
];

export const featuredProducts = verifiedProducts;
export const trendingProducts = verifiedProducts;
